import { injectable } from 'inversify';
import { resolve } from '@/app/container';
import { EventStreamListener } from '@/app/event-stream/event-stream-listener';
import { SectionProgressInterface, SectionProgressSymbol } from '../section/section-progress';
import { SectionInteractedEventName, SectionInteractionEvent } from '../events/section-interaction-events';
//import { QuestionEvent, QuestionAnsweredEventName } from '@/app/question/events/question-events';
// import { QuizEvent, QuizCompletedEventName } from '@/app/quiz/events/quiz-events';
//import { QUESTION_TYPE } from '../handlers/questions-completion-handler';
//import { QUIZ_TYPE } from '../handlers/quiz-completion-handler';
//import { isQuiz } from '@/app/quiz/utils/quiz-utils';
import sectionStoreModule from '../state/section-state';
import sectionInteractionStoreModule from '../state/section-interaction-state';

//type HandledEvents = SectionInteractionEvent|QuestionEvent|QuizEvent;
type HandledEvents = SectionInteractionEvent /*|QuizEvent*/;

@injectable()
export class SaveSectionInteraction implements EventStreamListener {
  // TODO: circular dependency - where?
  // @inject(PageCompletionServiceSymbol)
  // private pageCompletionService: PageCompletionService;

  public get events(): string[] {
    return [
      SectionInteractedEventName,
//      QuestionAnsweredEventName,
//      QuizCompletedEventName
    ];
  }

  public handle(event: HandledEvents): void {
    const sectionProgressService: SectionProgressInterface = resolve<SectionProgressInterface>(SectionProgressSymbol);

    let sectionId: string|null = this.getSectionId(event, sectionStoreModule.currentSectionId);
    if (sectionId === null) {
      return;
    }

    const interaction = this.getInteraction(event);
    if (interaction !== null) {
      const interactionSectionId: string|null = this.getSectionIdByInteraction(interaction, sectionProgressService);
      if (interactionSectionId !== null) {
        sectionId = interactionSectionId;
      }
    }

    sectionProgressService.saveInteraction(
      sectionId,
      interaction,
      this.getScrolled(event),
      this.getPage(event)
    ).then(() => null);
  }

  private getSectionId(event: HandledEvents, defaultValue: string|null = null): string|null {
    const payload: any = event.payload;
    if (payload.sectionId) {
      return payload.sectionId;
    }

    return defaultValue;
  }

  private getInteraction(event: HandledEvents): any|null {
    const payload: any = event.payload;
    if (payload.interaction) {
      return payload.interaction;
    }

    // if (isQuiz()) {
    //   return {
    //     id: payload.id,
    //     type: QUIZ_TYPE
    //   };
    // }

    // const isQuestionAnsweredEvent: boolean = event.name === QuestionAnsweredEventName;
    // if (isQuestionAnsweredEvent) {
    //   return {
    //     id: payload.id,
    //     type: QUESTION_TYPE
    //   };
    // }

    return null;
  }

  private getScrolled(event: HandledEvents): number|null {
    const payload: any = event.payload;
    if (payload.scrolledPercent) {
      return payload.scrolledPercent;
    }

    return null;
  }

  private getPage(event: HandledEvents): number|null {
    const payload: any = event.payload;
    if (payload.page) {
      return payload.page;
    }

    return null;
  }

  private getSectionIdByInteraction(interaction: any, sectionProgressService: SectionProgressInterface): string|null {
    if (interaction.type && interaction.id) {
      const interactionId: string = sectionProgressService.createInteractionId(interaction.type, interaction.id);
      if (sectionInteractionStoreModule.sectionIdsByInteraction[interactionId]) {
        return sectionInteractionStoreModule.sectionIdsByInteraction[interactionId];
      }

      return null;
    }

    return null;
  }
}
